/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';
import Spinner from 'app/shared/components/SpinnerContainer';

export default Loadable({
    loader: () => import('./index'),
    loading: Spinner,
});
